import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2, FileCheck2, FileSignature, Link2Off, MessageSquareWarning, ShieldAlert, Sparkles } from 'lucide-react';
import { C, num } from './theme';
import { Panel } from './KpiGrid';

const ICONS = { docs: FileCheck2, sign: FileSignature, comm: MessageSquareWarning, links: Link2Off, dnago: ShieldAlert };
const COLORS = { docs: C.purple, sign: C.magenta, comm: C.orange, links: C.amber, dnago: C.green };

export function OperationsBlock({ ops }) {
  const navigate = useNavigate();
  return (
    <Panel kicker="Operacional" title="Pendências reais por módulo" testid="block-operations"
      right={<span className="rounded-full px-3 py-1 text-[11px] font-bold" style={{ background: `${C.magenta}14`, color: C.magenta }} data-testid="ops-total">{num(ops.total)} no total</span>}>
      <div className="space-y-2">
        {ops.modules.map((m) => {
          const Icon = ICONS[m.key] || ShieldAlert;
          const ok = !m.count;
          return (
            <button key={m.key} type="button" onClick={() => navigate(m.path)} data-testid={`ops-${m.key}`}
              className="group flex w-full items-center gap-3 rounded-2xl border px-3.5 py-3 text-left transition-[transform,background-color] duration-150 hover:translate-x-0.5 hover:bg-[#FBF9FD]" style={{ borderColor: C.line }}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl" style={{ background: ok ? `${C.green}14` : `${COLORS[m.key]}16`, color: ok ? C.green : COLORS[m.key] }}>
                {ok ? <CheckCircle2 className="h-4.5 w-4.5" /> : <Icon className="h-4.5 w-4.5" />}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[13px] font-semibold" style={{ color: C.ink }}>{m.label}</span>
                <span className="block truncate text-[11.5px]" style={{ color: C.muted }}>{m.detail}</span>
              </span>
              <span className="text-lg font-extrabold tabular-nums" style={{ color: ok ? C.green : C.ink }} data-testid={`ops-${m.key}-count`}>{num(m.count)}</span>
              <ArrowUpRight className="h-4 w-4 opacity-0 transition-opacity group-hover:opacity-60" style={{ color: C.ink }} />
            </button>
          );
        })}
      </div>
    </Panel>
  );
}

const LEVEL = { alta: C.orange, media: C.amber, info: C.green };

export function InsightsBlock({ items }) {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden rounded-[24px] p-5 sm:p-6 text-white" style={{ background: C.aubergine }} data-testid="block-insights">
      <span className="pointer-events-none absolute -bottom-16 -right-10 h-48 w-48 rounded-full opacity-30" style={{ background: C.magenta }} />
      <span className="pointer-events-none absolute -top-10 right-16 h-24 w-24 rounded-full opacity-25" style={{ background: C.green }} />
      <div className="relative">
        <p className="flex items-center gap-2 text-[10.5px] font-bold uppercase tracking-[0.22em] text-white/60"><Sparkles className="h-3.5 w-3.5" /> Insights inteligentes</p>
        <h2 className="text-base md:text-lg font-extrabold" style={{ fontFamily: 'Manrope, sans-serif' }}>O que merece ação agora</h2>
        <div className="mt-4 space-y-2.5">
          {!items.length ? (
            <p className="rounded-2xl bg-white/10 p-4 text-sm text-white/80" data-testid="insights-empty">Nenhum alerta material no filtro atual.</p>
          ) : items.map((it, i) => (
            <button key={i} type="button" onClick={() => it.path && navigate(it.path)} data-testid={`insight-${i}`}
              className="w-full rounded-2xl bg-white/[.08] p-4 text-left backdrop-blur-md transition-[transform,background-color] duration-150 hover:-translate-y-0.5 hover:bg-white/[.14] dash-rise" style={{ animationDelay: `${i * 70}ms` }}>
              <span className="flex items-center gap-2 text-[13.5px] font-bold"><span className="h-2 w-2 shrink-0 rounded-full" style={{ background: LEVEL[it.level] || C.amber }} />{it.title}</span>
              <span className="mt-1 block text-[12.5px] leading-relaxed text-white/75">{it.text}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
